var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTealMaskRBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 553,
    height: 636,
    viewBox: "0 0 553 636",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M776.101 305.703C770.036 208.873 722.998 117.392 646.768 57.3952C577.866 3.16483 483.891 -11.4237 398.511 8.51835C327.563 25.0896 302.324 107.406 244.25 151.41C165.924 210.76 32.8163 211.063 6.30534 305.703C-21.6097 405.356 47.7513 510.328 124.161 580.109C197.566 647.146 299.119 662.615 398.511 663.883C499.582 665.173 606.612 656.775 679.954 587.203C754.732 516.269 782.545 408.583 776.101 305.703Z",
    fill: "#EEFFF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTealMaskRBg);
export default __webpack_public_path__ + "static/media/teal-mask-r-bg.63a36b1031f0d3b30fb1da3ee9293849.svg";
export { ForwardRef as ReactComponent };